import { useState } from 'react'
import axios from 'axios'
import toast from 'react-hot-toast'

export default function PublicDonationSection({ website, section, sectionFormStyling, useDefaultStyling = true }) {
  const [amount, setAmount] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const [reviewing, setReviewing] = useState(false)
  const content = section?.content || {}
  const formColors = sectionFormStyling || {
    backgroundColor: '#FFFFFF',
    textColor: '#111827',
    buttonBackgroundColor: '#3B82F6',
    buttonTextColor: '#FFFFFF',
    hoverButtonBackgroundColor: '#2563EB',
    hoverButtonTextColor: '#FFFFFF'
  }
  const inputStyle = {
    backgroundColor: formColors.backgroundColor,
    color: formColors.textColor
  }
  const buttonStyle = {
    backgroundColor: formColors.buttonBackgroundColor,
    color: formColors.buttonTextColor
  }
  const amountNumber = Number(amount)
  const currency = website?.paymentSettings?.currency || 'NGN'
  const formattedAmount = Number.isFinite(amountNumber)
    ? new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(amountNumber)
    : ''

  const handleSubmit = async (event) => {
    event.preventDefault()
    const numericAmount = Number(amount)
    if (!Number.isFinite(numericAmount) || numericAmount <= 0) {
      toast.error('Enter an amount greater than zero')
      return
    }

    setReviewing(true)
  }

  const handleConfirm = async () => {
    const numericAmount = Number(amount)
    setReviewing(false)
    setSubmitting(true)
    try {
      const response = await axios.post(`/store-payments/store/${website.publicUrl}/checkout`, {
        paymentType: 'donation',
        sectionId: section?._id,
        amount: numericAmount,
        currency,
        items: [{ itemType: 'donation', type: 'donation' }]
      })
      const redirectUrl = response.data?.data?.redirectUrl || response.data?.data?.authorizationUrl
      if (!redirectUrl) throw new Error('Payment authorization URL was not returned')
      window.location.assign(redirectUrl)
    } catch (error) {
      toast.error(error.response?.data?.message || error.message || 'Unable to initialize donation payment')
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <div className="w-full max-w-xl mx-auto">
      {content.donationName ? <h3 className="text-2xl font-semibold mb-3" style={{ color: formColors.textColor }}>{content.donationName}</h3> : null}
      {content.donationDescription ? <p className="mb-6 whitespace-pre-wrap" style={{ color: formColors.textColor }}>{content.donationDescription}</p> : null}
      <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 w-full">
        <label className="flex-1 min-w-0">
          <span className="sr-only">Donation amount</span>
          <input
            type="number"
            min="0.01"
            step="0.01"
            inputMode="decimal"
            value={amount}
            onChange={(event) => setAmount(event.target.value)}
            placeholder="Amount"
            className="input-field w-full"
            style={inputStyle}
            disabled={submitting}
          />
        </label>
        <button type="submit" className="px-5 py-3 rounded-md font-medium disabled:opacity-60" style={buttonStyle} disabled={submitting}>
          {submitting ? 'Processing...' : 'Donate'}
        </button>
      </form>
      {reviewing && (
        <div className="mt-6 rounded-lg border p-5" style={{ backgroundColor: formColors.backgroundColor, color: formColors.textColor }}>
          <h4 className="text-lg font-semibold mb-4">Review donation</h4>
          {content.donationName ? <p className="mb-2"><strong>Donation Title:</strong> {content.donationName}</p> : null}
          {content.donationDescription ? <p className="mb-2 whitespace-pre-wrap"><strong>Donation Description:</strong> {content.donationDescription}</p> : null}
          <p className="mb-4"><strong>Amount:</strong> {formattedAmount}</p>
          <div className="flex flex-col sm:flex-row gap-3">
            <button type="button" className="px-5 py-3 rounded-md font-medium" style={buttonStyle} onClick={handleConfirm}>Continue to payment</button>
            <button type="button" className="px-5 py-3 rounded-md font-medium border" style={{ color: formColors.textColor, borderColor: formColors.textColor }} onClick={() => setReviewing(false)}>Edit amount</button>
          </div>
        </div>
      )}
    </div>
  )
}
